import React from 'react';
import { ConfirmationDialog } from 'shared-portal-components-v2';

import type { ExternalUser } from '@/types/external-users.types';

interface DeleteExternalUserDialogProps {
  user: ExternalUser | null;
  onConfirm: () => void;
  onCancel: () => void;
}

function getSixMembershipSentence(user: ExternalUser): string {
  if (user.sixCount === 0) {
    return `${user.name} is not currently a member of any SIXs.`;
  }
  const sixLabel = user.sixCount === 1 ? 'SIX' : 'SIXs';
  return `${user.name} is a member of ${user.sixCount} ${sixLabel} and will permanently lose access to them if deleted.`;
}

// Note: the shared ConfirmationDialog closes itself synchronously after
// onConfirm, so no in-dialog pending state is possible; the global loader
// covers the in-flight window.
function DeleteExternalUserDialog({
  user,
  onConfirm,
  onCancel,
}: DeleteExternalUserDialogProps): React.ReactElement | null {
  if (user === null) {
    return null;
  }

  return (
    <ConfirmationDialog
      isOpen
      onClose={onCancel}
      title="Delete external user?"
      description={
        <span data-testid="delete-external-user-description">
          {getSixMembershipSentence(user)} This deletion will be recorded in the account audit log.
        </span>
      }
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmText="Delete"
      cancelText="Cancel"
    />
  );
}

export default DeleteExternalUserDialog;
